import React from 'react';
import { useParams } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import QuestionActionBar from '../../components/QuestionActionBar/QuestionActionBar';
import QuestionCard from '../../components/QuestionCard/QuestionCard';
import {
    deleteFresherQuestionData,
    getFresherQuestionData,
    postFresherQuestionData,
    updateFresherQuestionData,
} from '../../service/adminApi';
import './recruitmentform.css';

function QuestionFresher({ technicalQues = '' }) {
    const params = useParams();

    let checkQuestion = {
        id: '',
        question: '',
        option: [],
        is_required: false,
        long_answer: false,
    };

    const [showActionBar, setshowActionBar] = React.useState(false);
    const [questionDataList, setQuestionDataList] = React.useState([]);
    const [questionTypeList, setQuestionTypeList] = React.useState([]);
    const [flag, setFlag] = React.useState(false);
    const [type, setType] = React.useState();
    const [breadCrumbs, setBreadcrumbs] = React.useState([
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Recruitment Settings', path: '/admin/recuritementmessage', isActive: true },
    ]);

    React.useEffect(() => {
        if (params.dId !== undefined && params.dId !== '') {
            setType('exp');
            setBreadcrumbs((breadCrumbs) => [...breadCrumbs, { title: 'Questionnaires - Experienced', path: '', isActive: false }]);
            getQuestionList('exp', params.rId);
        }
    }, [params]);

    React.useEffect(() => {
        if (params.dId === undefined || params.dId === '') {
            setType('fresher');
            setBreadcrumbs((breadCrumbs) => [
                ...breadCrumbs,
                {
                    title:
                        technicalQues == 'technical'
                            ? 'Questions - Technical Skill Test'
                            : technicalQues == 'aptitude'
                                ? 'Questions - Aptitude Test'
                                : technicalQues == 'programming'
                                    ? 'Questions - Coding Challenge'
                                    : 'Questions - Preliminary',
                    path: '',
                    isActive: false,
                },
            ]);
            getQuestionList('fresher');
        }
    }, []);

    const hideNavBar = () => {
        setshowActionBar(false);
    };

    const getQuestionList = async (qType = '', paramsId = '') => {
        ;

        qType = qType !== '' ? qType : type;
        paramsId = paramsId !== '' ? paramsId : params.rId;
        const response = await getFresherQuestionData({
            type: qType,
            desigination_id: paramsId,
            admin: true,
            module: qType == 'fresher' && technicalQues ? technicalQues : 'preliminary',
        });

        let questionType = [];
        let questionData = [];
        for (let i = 0; i < response.data.data.length; i++) {
            questionData.push(response.data.data[i]);
            questionType.push(response.data.data[i].questiontype_id);
        }
        setQuestionDataList(questionData);
        setQuestionTypeList(questionType);
        setFlag(!flag);
    };

    const getQuestionData = (data) => {
        setQuestionTypeList((questionTypeList) => [...questionTypeList, data]);
        setQuestionDataList((questionDataList) => [...questionDataList, checkQuestion]);
    };

    const deleteQuestionData = async (index) => {
        let questionList = questionDataList;
        let typeList = questionTypeList;
        if (questionDataList[index].id === undefined || questionDataList[index].id === '') {
            let arr = questionList.splice(index, 1);
            let arr1 = typeList.splice(index, 1);
            let updatedData = questionList;
            let updatedData1 = typeList;
            setQuestionDataList(updatedData);
            setQuestionTypeList(updatedData1);
        } else {
            const response = await deleteFresherQuestionData({ id: questionDataList[index].id });
            if (response.data.statusCode === 200) {
                getQuestionList();
            }
        }

        setFlag(!flag);
    };

    const updateQuestionData = async (data, index) => {
        let questionData = questionDataList;
        questionData[index] = data;
        const postData = postQuestion(data, index);
        setQuestionDataList(questionData);

        if (data?.id === undefined || data?.id === '') {
            const response = await postFresherQuestionData({
                ...postData,
                module: postData.type == 'fresher' && technicalQues ? technicalQues : postData.type == 'exp' ? null : 'preliminary',
            });
            if (response.data.statusCode === 200) {
                getQuestionList();
            }
        } else {
            postData['id'] = data.id;
            const response = await updateFresherQuestionData(postData);
            if (response.data.statusCode === 200) {
                getQuestionList();
            }
        }
        setFlag(!flag);
    };

    const postQuestion = (data, index) => {
        let questionData = {
            question: data.question,
            options: data.option,
            isRequired: data.is_required,
            questiontype_id: data.questiontype_id,
            desigination_id: null,
            question_order: parseInt(index),
            answer: data?.answer || null,
            long_answer: data?.long_answer || null,
        };

        if (params.dId !== undefined || params.rId !== undefined) {
            questionData['desigination_id'] = params.rId;
            questionData['type'] = 'exp';
        } else {
            questionData['type'] = 'fresher';
        }

        return questionData;
    };

    const copyQuestion = (index, type) => {
        let data = questionDataList[index];
        data['id'] = '';
        setQuestionTypeList((questionTypeList) => [...questionTypeList, type]);
        setQuestionDataList((questionDataList) => [...questionDataList, data]);
        setFlag(!flag);
    };

    const moveQuestionList = (type, index) => {
        let arr = questionDataList;
        let arrIndex = questionTypeList;
        if (type === 'up') {
            const tmp = arr[index];
            arr[index] = arr[index - 1];
            arr[index - 1] = tmp;
            setQuestionDataList(arr);
            const tmpIndex = arrIndex[index];
            arrIndex[index] = arrIndex[index - 1];
            arrIndex[index - 1] = tmpIndex;
            setQuestionTypeList(arrIndex);
        } else if (type === 'down') {
            const tmp = arr[index];
            arr[index] = arr[index + 1];
            arr[index + 1] = tmp;
            setQuestionDataList(arr);
            const tmpIndex = arrIndex[index];
            arrIndex[index] = arrIndex[index + 1];
            arrIndex[index + 1] = tmpIndex;
            setQuestionTypeList(arrIndex);
        }
        setFlag(!flag);
    };

    const renderQuestionCard = () => {
        if (questionTypeList.length > 0) {
            return questionTypeList.map((dataList, index) => {
                return (
                    <QuestionCard
                        handleDelete={(data) => {
                            deleteQuestionData(data);
                        }}
                        questionData={questionDataList[index]}
                        questionType={dataList}
                        questionIndex={index}
                        updateQuestionData={(data, index) => {
                            updateQuestionData(data, index);
                        }}
                        copyQuestionData={(index, type) => {
                            copyQuestion(index, type);
                        }}
                        questionList={questionTypeList}
                        moveQuestion={(data, index) => {
                            moveQuestionList(data, index);
                        }}
                        module={technicalQues}
                        questionListLength={questionTypeList.length - 1}
                    />
                );
            });
        } else {
            return <></>;
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card mb-5">
            <BreadCrumbs data={breadCrumbs} />
            <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0 tt-bold font-18">
                    Questions -{' '}
                    {params.dId
                        ? `Experienced`
                        : technicalQues == 'technical'
                            ? `Technical Skill Test`
                            : technicalQues == 'aptitude'
                                ? 'Aptitude Test'
                                : technicalQues == 'programming'
                                    ? 'Coding Challenge'
                                    : `Preliminary`}{' '}
                </p>
                <button
                    onClick={() => {
                        setshowActionBar(true);
                    }}
                    type="button buttoncolor"
                    className="btn hive-btn-primary "
                >
                    <span>
                        <img src="/Images/recruit-plus-icon.svg" className=" me-2" />
                    </span>
                    New Questions
                </button>
            </div>
            {renderQuestionCard()}

            {showActionBar && (
                <QuestionActionBar
                    hideNavBar={() => {
                        hideNavBar();
                    }}
                    handleQuestionBar={(data) => {
                        getQuestionData(data);
                    }}
                />
            )}
        </div>
    );
}

export default QuestionFresher;
